
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.756 9.036c0-1.02-.38-1.9-1.142-2.362-.025-.024-.076-.024-.127 0-.33.208-.736.347-1.167.347-.432 0-.838-.139-1.168-.347-.025-.024-.076-.024-.127 0-.761.463-1.142 1.343-1.142 2.362.026.694 4.873.694 4.873 0z","fill":"#000"}}),_c('path',{attrs:{"d":"M8.32 6.558c.799 0 1.447-.591 1.447-1.32 0-.73-.648-1.32-1.447-1.32-.8 0-1.447.59-1.447 1.32 0 .729.648 1.32 1.447 1.32z","fill":"#000"}}),_c('path',{attrs:{"d":"M20.02 1H3.98C2.888 1 2 1.81 2 2.806v18.388C2 22.189 2.888 23 3.98 23h16.04c1.092 0 1.98-.81 1.98-1.806V2.806C22 1.811 21.112 1 20.02 1zm1.015 20.194c0 .51-.456.926-1.015.926H3.98c-.559 0-1.016-.417-1.016-.926V2.806c0-.51.457-.926 1.016-.926h16.04c.559 0 1.015.417 1.015.926v18.388z","fill":"#000"}}),_c('path',{attrs:{"d":"M17.888 11.56H6.112c-.254 0-.483.185-.483.44 0 .254.204.44.483.44h11.751c.254 0 .482-.186.482-.44 0-.255-.203-.44-.457-.44z","fill":"#000"}}),_c('path',{attrs:{"d":"M17.888 7.901h-5.127c-.253 0-.482.186-.482.44 0 .255.203.44.482.44h5.102c.254 0 .482-.185.482-.44a.44.44 0 00-.457-.44z","fill":"#000"}}),_c('path',{attrs:{"d":"M17.888 4.242h-5.127c-.253 0-.482.185-.482.44 0 .232.203.44.482.44h5.102c.254 0 .482-.185.482-.44a.44.44 0 00-.457-.44z","fill":"#000"}}),_c('path',{attrs:{"d":"M17.888 15.219H6.112c-.254 0-.483.185-.483.44s.204.44.483.44h11.751c.254 0 .482-.185.482-.44s-.203-.44-.457-.44z","fill":"#000"}}),_c('path',{attrs:{"d":"M17.888 18.878H6.112c-.254 0-.483.185-.483.44s.204.44.483.44h11.751c.254 0 .482-.185.482-.44a.44.44 0 00-.457-.44z","fill":"#000"}})])
          )
        }
      }
    